// Barre collante en bas sur téléphone : le prix et le bouton, visibles une
// fois le hero passé et jusqu'à la grille tarifaire.
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useT } from '../../lib/i18n'

export default function StickyCta () {
  const t = useT()
  const [show, setShow] = useState(false)

  useEffect(() => {
    let raf = 0
    function compute () {
      raf = 0
      const passedHero = window.scrollY > window.innerHeight * 0.9
      const plans = document.getElementById('pricing')
      const plansReached = plans ? plans.getBoundingClientRect().top < window.innerHeight - 80 : false
      setShow(passedHero && !plansReached)
    }
    function onScroll () { if (!raf) raf = requestAnimationFrame(compute) }
    compute()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
      if (raf) cancelAnimationFrame(raf)
    }
  }, [])

  return (
    <div className={`lp-sticky${show ? ' lp-sticky--on' : ''}`}>
      <div className="lp-sticky__in">
        <span className="lp-sticky__t">{t.sticky.text}</span>
        <Link to="/register" className="lp-btn lp-btn--main lp-btn--sm">{t.sticky.cta}</Link>
      </div>
    </div>
  )
}
